import { render, staticRenderFns } from "./DocumentViewerModal.vue?vue&type=template&id=b020e984&"
import script from "./DocumentViewerModal.vue?vue&type=script&lang=js&"
export * from "./DocumentViewerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports